import FeatherIcon from 'feather-icons-react'
import { Button } from 'react-bootstrap'

const AddButton = (props) => {
  const { handleAdd, uischema } = props
  const { addLabel = 'เพิ่ม' } = uischema.tableAction || {}

  return (
    <Button variant="outline-primary" onClick={handleAdd}>
      <FeatherIcon size="14" icon="plus-square" className="mr-1" />
      {addLabel}
    </Button>
  )
}

export default AddButton
